// extracted by mini-css-extract-plugin
export default {"gridRow":"dashboard-gridarea_gridRow__nupSk"};